import { render, staticRenderFns } from "./SupplierPrimaryKeyAdd.vue?vue&type=template&id=0a7928eb&scoped=true&"
import script from "./SupplierPrimaryKeyAdd.vue?vue&type=script&lang=js&"
export * from "./SupplierPrimaryKeyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7928eb",
  null
  
)

export default component.exports